export default "__VITE_ASSET__DSYdc0Wz__"